import styled from 'styled-components';

export const Cancel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  align-self: stretch;
  gap: 1rem;
  font-size: 1rem;
  text-align: center;
`;
